// Helper function to setup scrollbar visibility handler
export function setupScrollbarVisibility(
  element: HTMLElement | null,
  className: string = 'scrolling'
): (() => void) | undefined {
  if (!element) return undefined

  let scrollTimeout: NodeJS.Timeout | null = null

  const handleScroll = () => {
    // Add scrolling class
    element.classList.add(className)
    
    // Clear existing timeout
    if (scrollTimeout) {
      clearTimeout(scrollTimeout)
    }
    
    // Remove scrolling class after 1 second of no scrolling
    scrollTimeout = setTimeout(() => {
      element.classList.remove(className)
    }, 1000)
  }

  element.addEventListener('scroll', handleScroll, { passive: true })

  return () => {
    element.removeEventListener('scroll', handleScroll)
    if (scrollTimeout) {
      clearTimeout(scrollTimeout)
    }
  }
}
